import { createSelector } from "@reduxjs/toolkit";
import { choSearch, registQuery } from "../../functions/searchFunctions";
import { LOCALES, SAVIOR_CLASS } from "../../constants";

const selectLang = (state) => state.lang;

export const selectPotentialState = (state) => state.potentials;

export const selectPotentialIds = (state) => selectPotentialState(state).ids;

export const selectPotentialEntities = (state) => selectPotentialState(state).entities;

export const selectPotentialFilter = (state) => selectPotentialState(state).filter;

const filterByType = (potential, type) => {
    if (type.value === "all") return true;
    return potential.type === type.value;
};

const filterByRole = (potential, role) => {
    if (role.value === "all") return true;
    return potential.class === SAVIOR_CLASS[role.value]?.[LOCALES.KO];
};

const searchByText = (lang, potential, query) => {
    const q = String(query).trim();
    if (q === "") return true;

    registQuery(lang, q);
    const searchText = lang === LOCALES.KO ? potential.searchText : potential.searchText_ENG;
    return choSearch(searchText);
};

export const selectFilteredPotentials = createSelector(
    [selectPotentialIds, selectPotentialEntities, selectPotentialFilter, selectLang, (_, query) => query],
    (ids, entities, filter, lang, query) => {
        return ids
            .map((id) => entities[id])
            .filter((potential) => filterByType(potential, filter.potential_type))
            .filter((potential) => filterByRole(potential, filter.potential_role))
            .filter((potential) => searchByText(lang.value, potential, query));
    },
);
